import {
  fetchWithOutToken,
  fetchWithToken_old,
  fetchWithOutToken_old,
} from "@/utils/fetchApi";

export const resetPasswordByOtp = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/user/sent-reset-password-otp",
    data,
    { method: "POST" }
  );
  if (response.error) {
    return { response };
  }
  return response;
};

export const changeLoginPassword = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/user/reset-password",
    data,
    { method: "POST" }
  );
  if (response.error) {
    return { response };
  }
  return response;
};

export const getOtpRegister = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/user/signup-with-otp",
    data,
    { method: "POST" }
  );
  if (response.error) {
    return { response };
  }
  return response;
};

export const fileUrlUpload = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/file/upload",
    data,
    { method: "POST" }
  );
  if (response.error) {
    return { response };
  }
  return response;
};

export const summitRegisterData = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/user/register-student-with-otp",
    data,
    { method: "POST" }
  );
  if (response.error) {
    return { response };
  }
  return response;
};

export const getInitialData = async (path, params = {}) => {
  const response = await fetchWithOutToken(
    `/api/s/dynamic-page/${path}`,
    params
  );
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getCourses = async () => {
  const response = await fetchWithOutToken_old(`/api/public/data/all-courses`);
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getSession = async () => {
  const response = await fetchWithOutToken_old(`/api/public/data/sessions`);
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getAllCenters = async () => {
  const response = await fetchWithOutToken_old(`/api/public/data/centers`);
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getStream = async () => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/all-stream?status=true`
  );
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getWebberListItem = async (params = {}) => {
  const response = await fetchWithOutToken(`/api/s/webberlistitem`, params);
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const createEnquiry = async (data) => {
  const response = await fetchWithOutToken_old("/api/enquiry/enquiry", data, {
    method: "POST",
  });
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

// Buy module API
export const getProductResponse = async (id) => {
  const response = await fetchWithOutToken(
    `https://v3.edkt.net/api/s/product/${id}`
  );
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getCourseById = async (params = {}) => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/courses`,
    params
  );
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const placeOrder = async (data) => {
  const response = await fetchWithToken_old(
    "/api/cmn/order/place-order",
    data,
    { method: "POST" }
  );
  if (response.error) {
    return { response };
  }
  return response;
};

export const getProductBatch = async (params = {}) => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/product-batches`,
    params
  );
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getPayMentNode = async (params = {}) => {
  const response = await fetchWithToken_old(
    `/api/cmn/order/payment-nodes`,
    params
  );
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const applyCouponCode = async (id, data) => {
  const response = await fetchWithToken_old(
    `/api/cmn/order/${id}/add-discount`,
    data,
    { method: "POST" }
  );
  if (response.error) {
    return { response };
  }
  return response;
};

export const getCouponCodeDiscount = async (params = {}) => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/get-coupon-discount`,
    params
  );
  if (response.error) {
    return { response };
  }
  return response;
};

export const getEmiPaymentOptions = async (id) => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/product/${id}/payment-options`
  );
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getPopup = async (params = {}) => {
  const response = await fetchWithOutToken(`/api/s/popup`, params);
  if (response.error) {
    return { error: response.error, details: response?.details };
  }
  return response;
};
